import { getData } from "../../Survey/helpers/fetch_services";

function buildRecipientPackageQuery({
  inviteId,
  packageId,
  userId,
  guidanceVersion,
} = {}) {
  const params = new URLSearchParams();

  if (inviteId) {
    params.set("invite_id", inviteId);
  }

  if (packageId) {
    params.set("package_id", packageId);
  }

  if (userId) {
    params.set("user_id", userId);
  }

  if (guidanceVersion != null && guidanceVersion !== "") {
    params.set("guidance_version", guidanceVersion);
  }

  const query = params.toString();
  return query ? `?${query}` : "";
}

/** Loads invite progress from `GET ld-invitation/recipient-package`. */
export async function fetchLearningInvitePackage({
  inviteId,
  packageId,
  userId,
  guidanceVersion,
} = {}) {
  if (!inviteId || !packageId) {
    return null;
  }

  const query = buildRecipientPackageQuery({
    inviteId,
    packageId,
    userId,
    guidanceVersion,
  });
  const result = await getData(`ld-invitation/recipient-package${query}`);
  const payload = result?.data?.data ?? result?.data ?? result;

  if (
    payload &&
    typeof payload === "object" &&
    ("locked" in payload || "attempts" in payload)
  ) {
    return payload;
  }

  throw new Error(result?.message || "Unable to load invite progress.");
}
